/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFastfoodIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-fastfood"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.1 6.3Q9.47 6.3 10.8 6.72Q12.13 7.15 13.2 7.95Q14.28 8.75 15.03 9.88Q15.78 11 16.02 12.4Q16.15 13 15.75 13.47Q15.35 13.95 14.72 13.95L1.48 13.95Q0.85 13.95 0.45 13.47Q0.05 13 0.17 12.4Q0.42 11 1.18 9.88Q1.93 8.75 3 7.95Q4.08 7.15 5.4 6.72Q6.72 6.3 8.1 6.3ZM1.23 18.95Q0.68 18.95 0.29 18.56Q-0.1 18.18 -0.1 17.63Q-0.1 17.07 0.29 16.69Q0.68 16.3 1.23 16.3L14.97 16.3Q15.53 16.3 15.91 16.69Q16.3 17.07 16.3 17.63Q16.3 18.18 15.91 18.56Q15.53 18.95 14.97 18.95ZM1.23 23.95Q0.68 23.95 0.29 23.56Q-0.1 23.18 -0.1 22.63Q-0.1 22.07 0.29 21.69Q0.68 21.3 1.23 21.3L14.97 21.3Q15.53 21.3 15.91 21.69Q16.3 22.07 16.3 22.63Q16.3 23.18 15.91 23.56Q15.53 23.95 14.97 23.95ZM20.95 23.95L19.63 23.95Q19.07 23.95 18.69 23.56Q18.3 23.18 18.3 22.63L18.3 13.95Q18.3 11.53 17.18 9.44Q16.05 7.35 14.05 6.03Q13.88 5.9 13.71 5.79Q13.55 5.67 13.4 5.53L13.32 5.45Q12.65 4.83 12.99 3.99Q13.32 3.15 14.22 3.15L16.1 3.15L16.1 1.38Q16.1 0.82 16.49 0.44Q16.88 0.05 17.43 0.05Q17.98 0.05 18.36 0.44Q18.75 0.82 18.75 1.38L18.75 3.15L22.65 3.15Q23.23 3.15 23.63 3.59Q24.02 4.03 23.98 4.6L22.27 22.75Q22.23 23.25 21.84 23.6Q21.45 23.95 20.95 23.95Z" fill={color} />
    </svg>
  );
}
